/**
 * it will compare the { start } from the d with the [min] from the minMax,
 * then returns the larger date as the start date
 *
 * then it compare { end } from the d with the [max] from the minMax,
 * it returns the smaller date as the end date
 *
 * @param d  start: string, end: string
 * @param minMax [Date, Date]
 */
export function getStartEndDate(d, minMax) {
    var start = new Date(d.start).getTime() < minMax[0].getTime()
        ? minMax[0]
        : new Date(d.start);
    var end = minMax[1].getTime() < new Date(d.end).getTime()
        ? minMax[1]
        : new Date(d.end);
    return {
        start: start,
        end: end
    };
}
//# sourceMappingURL=getStartEndDate.js.map